import { apiAuth } from "../../http";

export const getProfileById = async (id: string): Promise<any> => {
  const response = apiAuth()
    .get(`/profiles/${id}`)
    .then(({ data }) => data);
  return response;
};
